import uiCore = require("../core/uicore");
import dataCore = require("../core/datacore");
import entityCache = require("../core/entitycache");
import personcompetencescommon = require("./personcompetences.common");

class CompetencesUISettings {
    public referenceDate: Date;
    public valid: boolean;
    public warning: boolean;
    public invalid: boolean;
    public expired: boolean;
    public future: boolean;
}

var __uiSettings: CompetencesUISettings = {
    referenceDate: new Date(),
    valid: true,
    warning: true,
    expired: false,
    invalid: true,
    future: false,
};

var competencesEntityManager: entityCache.CommonEntityManagersClass = new entityCache.CommonEntityManagersClass();

class CompetenceWithInfo {
    public state: dataCore.CompetenceState;
    public comp: Nema.Crew.Model.PersonCompetence;

    public static CreateArray(settings: CompetencesUISettings, personCompetences: Nema.Crew.Model.PersonCompetence[]) {
        var result = [];

        for (var i = 0; i < personCompetences.length; i++) {
            var personCompetence = personCompetences[i];
            var state = dataCore.computeCompetenceState(personCompetence.ValidFrom, personCompetence.Expiration, settings.referenceDate, personCompetence.CompetenceType.WarningTimeNrMonths);
            switch (state) {
                case dataCore.CompetenceState.Valid:
                    if (settings.valid) result.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Warning:
                    if (settings.warning) result.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Expired:
                    if (settings.expired) result.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Invalid:
                    if (settings.invalid) result.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Future:
                    if (settings.future) result.push(new CompetenceWithInfo(state, personCompetence));
                    break;
            }
        }
        return result;
    }

    constructor(state: dataCore.CompetenceState, personComptence: Nema.Crew.Model.PersonCompetence) {
        this.comp = personComptence;
        this.state = state;
    }
}

class CompetenceGroupWithFilteredInfo {

    public competenceGroup: Nema.Crew.Model.CompetenceGroup;
    public competenceInfos: CompetenceWithInfo[];

    constructor(competenceGroup: Nema.Crew.Model.CompetenceGroup) {
        this.competenceGroup = competenceGroup;
        this.competenceInfos = [];
    }

    public pushInfos(settings: CompetencesUISettings) {
        var targetArray = this.competenceInfos;
        targetArray.length = 0;
        var personCompetenceArrays = this.competenceGroup.CompetenceTypes.map(cts => cts.PersonCompetences);
        var personCompetences = [];
        personCompetences = personCompetences.concat.apply(personCompetences, personCompetenceArrays);

        for (var i = 0; i < personCompetences.length; i++) {
            var personCompetence = personCompetences[i];
            var state = dataCore.computeCompetenceState(personCompetence.ValidFrom, personCompetence.Expiration, settings.referenceDate, personCompetence.CompetenceType.WarningTimeNrMonths);
            switch (state) {
                case dataCore.CompetenceState.Valid:
                    if (settings.valid) targetArray.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Warning:
                    if (settings.warning) targetArray.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Expired:
                    if (settings.expired) targetArray.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Invalid:
                    if (settings.invalid) targetArray.push(new CompetenceWithInfo(state, personCompetence));
                    break;
                case dataCore.CompetenceState.Future:
                    if (settings.future) targetArray.push(new CompetenceWithInfo(state, personCompetence));
                    break;
            }
        }
    }
}

export class PersonDetailsCompetencesDirective implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "crewpersondetailscompetences",
        Template: require("./person.details.competences.html"),
        AngularDependencies: [uiCore.ScopeDependency, uiCore.StateDependency, uiCore.MdDialogDependency],
        Bindings: {
            person: "=",
        },
        //Filters: [filterCompeteteceInfoFilter]
    }

    constructor(...args: any[]) {
        this._locator = uiCore.DependencyLocator.Create(PersonDetailsCompetencesDirective, args);
        this.uiSettings = __uiSettings;
        var dataCache = new entityCache.EntityCache(competencesEntityManager.EntityManager);

        var self = this;

        dataCache.getEntitySetsPromise([entityCache.EntityTypeNames.CompetenceType, entityCache.EntityTypeNames.CompetenceGroup])
            .then(res => {
                var competenceGroups: Nema.Crew.Model.CompetenceGroup[] = <any>res[entityCache.EntityTypeNames.CompetenceGroup];
                if (competenceGroups) {
                    self.competenceGroupWithFilteredInfos = competenceGroups.map(cg => new CompetenceGroupWithFilteredInfo(cg));
                }
            });

        uiCore.applyOnFirstNotNull(this._locator.getScopeDependency(), "vm.person", () => {
            dataCache.markForRefresh([entityCache.EntityTypeNames.PersonCompetence]);
            dataCache.getEntityQueriesPromise([
                { queryId: entityCache.EntityTypeNames.PersonCompetence, applyQuery: query => query.where("PersonId", '==', this.person.Id), entityTypeName: entityCache.EntityTypeNames.PersonCompetence },
            ])
                .then(_res => {
                    self.setPersonCompetences();
                    self._locator.getScopeDependency().$watchGroup(["vm.uiSettings.valid", "vm.uiSettings.warning", "vm.uiSettings.expired", "vm.uiSettings.invalid", "vm.uiSettings.future", "vm.uiSettings.referenceDate"], (_oldValues, _newValues) => {
                        self.setPersonCompetences();

                    });

                }).catch(_reason => {
                });
        });
    }

    setPersonCompetences() {
        if (this.competenceGroupWithFilteredInfos && this.person) {
            for (var i = 0; i < this.competenceGroupWithFilteredInfos.length; i++) {
                this.competenceGroupWithFilteredInfos[i].pushInfos(this.uiSettings);
            }
        };
        uiCore.safeScopeApply(this._locator.getScopeDependency());
    }

    person: Nema.Crew.Model.Person;
    competenceGroupWithFilteredInfos: CompetenceGroupWithFilteredInfo[];


    private _locator: uiCore.DependencyLocator;

    public uiSettings: CompetencesUISettings;

    public viewComment(competence: CompetenceWithInfo) {
        if (competence && competence.comp && competence.comp.Description)
            personcompetencescommon.viewComment(competence.comp.Description, this._locator.getMdDialogDependency());
    }

    public viewAttachment(competence: CompetenceWithInfo) {
        if (competence && competence.comp) personcompetencescommon.downloadAttachment(competence.comp.Id);
    }

    public goToDetails(competence: CompetenceWithInfo) {
        this._locator
            .getStateDependency()
            .go("app." + personcompetencescommon.PersonCompetenceStateStrings.Details, <personcompetencescommon.PersonCompetenceStateParams>{ personCompetenceId: competence.comp.Id, personId: competence.comp.PersonId });
    }

    public goToNew() {
        this._locator
            .getStateDependency()
            .go("app." + personcompetencescommon.PersonCompetenceStateStrings.New, <personcompetencescommon.PersonCompetenceStateParams>{ personCompetenceId: -1, personId: this.person.Id });
    }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/person.details.competences.ts